import React, { Component } from "react";

interface IProps {
    [x: string]: any;
}

interface IState {

}
interface IStore {
    [x: string]: any;
}
interface IState {
    [x: string]: any;

}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {
    [x: string]: any;
}

export class ReelObject extends Component<IProps, IState> {
    protected ImgData: any;
    protected modifyData: any;
    constructor(props: IProps) {
        super(props);
        this.state = {
            imgindex: -1,
            Boxindex: null,
            imgindexMain: -1,
            BoxindexMain: null
        };
        this.ImgData = props.imageData;
        if (props.type == "NORMAL_REEL") {
            this.modifyData = props.MainReelData[props.index];
        } else {
            this.modifyData = props.HorizontalData[props.index];
        }

      
    }
    Indexinc(i: any) {

        if (i === this.ImgData.length - 1) {


            this.modifyData.symbol = this.modifyData.symbol;
        } else {
            // this.setState(() => ({
            //     imgindex: this.state.imgindex + 1,

            // }));
            this.modifyData.symbol = this.modifyData.symbol + 1
        }
        this.props.updateCheat.call(this.props.scope);
        this.forceUpdate();
    }
    Indexdec(i: any) {
        if (i === -1) {
            // this.setState(() => ({
            //     imgindex: -1,

            // }));
            this.modifyData.symbol = - 1;
        } else {
            // this.setState(() => ({
            //     imgindex: this.state.imgindex - 1,


            // }));
            this.modifyData.symbol = this.modifyData.symbol - 1;
        }
        this.props.updateCheat.call(this.props.scope);
        this.forceUpdate();

    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.forcechecked !== this.props.forcechecked) {
           
            if (!nextProps.forcechecked) {

                this.modifyData.symbol = - 1;
            }
            //return true
        }
        return true
    }
    render() {
        return <>
            <span>{this.modifyData.symbol}</span>
            {this.modifyData.symbol >= 0 ? <div style={{ border: "1px solid gray", height: "40px", width: "40px", objectFit: "contain" }} className="imgBox" ><img src={this.ImgData[this.modifyData.symbol].img} height="100%" width="100%" /></div> : <div style={{ border: "none", height: "40px", width: "40px" }}></div>}
            <span className="inc-dec">
                <span onClick={() => { this.Indexinc(this.modifyData.symbol) }}>+</span>
                <span onClick={() => { this.Indexdec(this.modifyData.symbol) }}>-</span>
            </span>
        </>
    }
}